var map = {
	"./": 318,
	"./Content": 1140,
	"./Content.dictionary": 1142,
	"./Content.dictionary.json": 1142,
	"./Content.jsx": 1140,
	"./ContentDeferred": 369,
	"./ContentDeferred.jsx": 369,
	"./InterestingMatches": 1020,
	"./InterestingMatches/": 1020,
	"./InterestingMatches/InterestingMatches.dictionary": 1034,
	"./InterestingMatches/InterestingMatches.dictionary.json": 1034,
	"./InterestingMatches/InterestingMatches.module.scss": 840,
	"./InterestingMatches/actions": 98,
	"./InterestingMatches/actions.ts": 98,
	"./InterestingMatches/components/Contetnt": 926,
	"./InterestingMatches/components/Contetnt/": 926,
	"./InterestingMatches/components/Contetnt/Content.dictionary": 972,
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": 972,
	"./InterestingMatches/components/Contetnt/Content.module.scss": 1033,
	"./InterestingMatches/components/Contetnt/index": 926,
	"./InterestingMatches/components/Contetnt/index.tsx": 926,
	"./InterestingMatches/components/Match": 844,
	"./InterestingMatches/components/Match/": 844,
	"./InterestingMatches/components/Match/Match.dictionary": 851,
	"./InterestingMatches/components/Match/Match.dictionary.json": 851,
	"./InterestingMatches/components/Match/index": 844,
	"./InterestingMatches/components/Match/index.tsx": 844,
	"./InterestingMatches/components/Sport": 971,
	"./InterestingMatches/components/Sport.tsx": 971,
	"./InterestingMatches/components/Stage": 875,
	"./InterestingMatches/components/Stage.tsx": 875,
	"./InterestingMatches/components/Tournament": 894,
	"./InterestingMatches/components/Tournament.jsx": 894,
	"./InterestingMatches/components/Union": 927,
	"./InterestingMatches/components/Union.jsx": 927,
	"./InterestingMatches/constants": 928,
	"./InterestingMatches/constants.ts": 928,
	"./InterestingMatches/index": 1020,
	"./InterestingMatches/index.jsx": 1020,
	"./InterestingMatches/reducer": 296,
	"./InterestingMatches/reducer/": 296,
	"./InterestingMatches/reducer/entities": 354,
	"./InterestingMatches/reducer/entities.js": 354,
	"./InterestingMatches/reducer/grid": 355,
	"./InterestingMatches/reducer/grid.js": 355,
	"./InterestingMatches/reducer/index": 296,
	"./InterestingMatches/reducer/index.js": 296,
	"./InterestingMatches/selectors": 831,
	"./InterestingMatches/selectors/": 831,
	"./InterestingMatches/selectors/entities": 274,
	"./InterestingMatches/selectors/entities.ts": 274,
	"./InterestingMatches/selectors/grid": 850,
	"./InterestingMatches/selectors/grid.ts": 850,
	"./InterestingMatches/selectors/index": 831,
	"./InterestingMatches/selectors/index.ts": 831,
	"./LandingPage.module.scss": 1181,
	"./MatchOfTheDay": 1021,
	"./MatchOfTheDay/": 1021,
	"./MatchOfTheDay/actions": 306,
	"./MatchOfTheDay/actions.ts": 306,
	"./MatchOfTheDay/components/Carousel": 973,
	"./MatchOfTheDay/components/Carousel/": 973,
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": 1141,
	"./MatchOfTheDay/components/Carousel/index": 973,
	"./MatchOfTheDay/components/Carousel/index.tsx": 973,
	"./MatchOfTheDay/components/MainStakes": 929,
	"./MatchOfTheDay/components/MainStakes/": 929,
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": 1035,
	"./MatchOfTheDay/components/MainStakes/index": 929,
	"./MatchOfTheDay/components/MainStakes/index.tsx": 929,
	"./MatchOfTheDay/components/MatchTile": 974,
	"./MatchOfTheDay/components/MatchTile/": 974,
	"./MatchOfTheDay/components/MatchTile/MatchDetails": 1036,
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": 1036,
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": 975,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": 1037,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": 1037,
	"./MatchOfTheDay/components/MatchTile/index": 974,
	"./MatchOfTheDay/components/MatchTile/index.tsx": 974,
	"./MatchOfTheDay/images/background.svg": 1201,
	"./MatchOfTheDay/images/pattern.svg": 1202,
	"./MatchOfTheDay/index": 1021,
	"./MatchOfTheDay/index.tsx": 1021,
	"./MatchOfTheDay/reducer": 356,
	"./MatchOfTheDay/reducer.ts": 356,
	"./MatchOfTheDay/selectors": 885,
	"./MatchOfTheDay/selectors/": 885,
	"./MatchOfTheDay/selectors/entities": 283,
	"./MatchOfTheDay/selectors/entities.ts": 283,
	"./MatchOfTheDay/selectors/grid": 917,
	"./MatchOfTheDay/selectors/grid.ts": 917,
	"./MatchOfTheDay/selectors/index": 885,
	"./MatchOfTheDay/selectors/index.ts": 885,
	"./MatchOfTheDay/utils/get-match-ids-from-banners": 1082,
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": 1082,
	"./MiniBanners": 1022,
	"./MiniBanners/": 1022,
	"./MiniBanners/MiniBanners": 976,
	"./MiniBanners/MiniBanners.module.scss": 1038,
	"./MiniBanners/MiniBanners.tsx": 976,
	"./MiniBanners/components/Content": 895,
	"./MiniBanners/components/Content/": 895,
	"./MiniBanners/components/Content/Content": 876,
	"./MiniBanners/components/Content/Content.module.scss": 930,
	"./MiniBanners/components/Content/Content.tsx": 876,
	"./MiniBanners/components/Content/index": 895,
	"./MiniBanners/components/Content/index.ts": 895,
	"./MiniBanners/index": 1022,
	"./MiniBanners/index.ts": 1022,
	"./images/telegram.svg": 1203,
	"./index": 318,
	"./index.tsx": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1273;
module.exports = webpackContext;